// extracted by mini-css-extract-plugin
module.exports = {"chatbot":"EGSlO","mobileDefaultArrow":"_3I4xP"};